import { formatCurrency } from '@monorepo/utils';
import React from 'react';
import { Col, Divider, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import CustomCard from '../CustomCard';
import styles from './index.module.scss';
import { getShippingRows } from '../../../../core/utils/helperFunc';

function OrderDetail({ orderDetails }) {
  const { t } = useTranslation();

  const communicator = {
    title: t('orderComplain.subTitle.infoReceiver'),
    name: orderDetails?.senderName,
    phone: orderDetails?.senderPhone,
    address: orderDetails?.senderAddress,
  };

  const orderInfoTitle = t('orderComplain.subTitle.infoOrder');

  const infoRows = [
    { label: t('orderComplain.mdh'), value: orderDetails?.number },
    { label: t('orderComplain.gtdh'), value: formatCurrency(orderDetails?.total), className: styles['order-value'] },
    ...getShippingRows(orderDetails?.shippingType, orderDetails?.shippingConfiguration, orderDetails?.shippingTypeName),
    // Cùng chữ với màn chi tiết đơn: của BE trước, rỗng thì hiện enum.
    {
      label: t('orderComplain.pttt'),
      value: orderDetails?.paymentMethodName || orderDetails?.paymentMethod || t('orderTracking.no'),
    },
  ];

  return (
    <CustomCard
      title={<span className={styles['title-card']}>{t('orderComplain.title.orderComplain')}</span>}
    >
      <div className={styles['wrap-content']}>
        <div>
          <div className={`${styles['sub-title']} ${styles['mt-10']}`}>{communicator.title}</div>
          <div className={`${styles['content-text']}`}>{communicator.name}</div>
          <div className={`${styles['content-text']}`}>{communicator.phone}</div>
          <div className={`${styles['content-text']}`}>{communicator.address}</div>
        </div>
        <Divider className={`${styles['line']}`} />
        <div>
          <div className={`${styles['sub-title']} ${styles['mt-10']}`}>{orderInfoTitle}</div>
          {/* Mỗi dòng 1 cặp nhãn–giá trị: số dòng vận chuyển đổi theo loại, tách 2 cột thì giá trị dài xuống
              dòng sẽ đẩy lệch các dòng dưới. Nhãn rộng cố định để giá trị vẫn thẳng hàng. */}
          {infoRows.map(({ label, value, className }) => (
            <Row wrap={false} gutter={[20]} key={label} className={styles['info-row']}>
              <Col flex="none" className={`${styles['info-label']} ${styles['content-text']}`}>
                {label}:
              </Col>
              <Col flex="auto" className={`${className || ''} ${styles['content-text']}`}>
                {value}
              </Col>
            </Row>
          ))}
        </div>
      </div>
    </CustomCard>
  );
}

export default OrderDetail;
